export default "__VITE_ASSET__ovglymIa__"